var _rect, _path, _circle, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 39,
    viewBox: "0 0 53 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 39,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 27V30H29V26.5L27.356 25.0133C25.5341 23.3656 23.3182 22.2154 20.9222 21.6737C18.9578 21.2296 16.9217 21.2057 14.9474 21.6036L14.8573 21.6218C12.0158 22.1945 9.40661 23.5934 7.35694 25.6431L6 27Z",
    fill: "blue"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 13,
    r: 5,
    fill: "blue"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 8,
    width: 18,
    height: 13,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14.5L31 10V12.5L38 17L44.5 12.5V10L38 14.5Z",
    fill: "blue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.e114b6b39fa4a6ff5bb0d5c2ab182899.svg";
export { ForwardRef as ReactComponent };